import { Controller } from '@hotwired/stimulus'
import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'
import { put } from '@rails/request.js'
import MobileDetect from 'mobile-detect'

export default class extends Controller {
  static values = {
    viewed: Boolean
  }

  connect() {
    if (this.viewedValue) {
      return
    }

    this.startTour()
  }

  startTour() {
    const md = new MobileDetect(window.navigator.userAgent)
    const isMobile = md.mobile() !== null

    const steps = isMobile ? this.mobileSteps() : this.desktopSteps()

    const driverObj = driver({
      showProgress: true,
      animate: true,
      overlayColor: 'rgba(0, 0, 0, 0.75)',
      popoverClass: 'driver-popover-theme',
      steps: steps,
      onDestroyStarted: () => {
        this.markAsViewed()
        driverObj.destroy()
      }
    })

    driverObj.drive()
  }

  desktopSteps() {
    return [
      {
        element: '[data-driver="sidebar"]',
        popover: {
          title: 'Navigation',
          description: 'This is your main navigation. Access all of AutoScribe\'s features from here including Projects, Posts, Keywords, and more.',
          side: 'right',
          align: 'start'
        }
      },
      {
        element: '[data-driver="metrics"]',
        popover: {
          title: 'Your Content Metrics',
          description: 'Track your content at a glance. See your total posts, published content, drafts, and keyword count.',
          side: 'bottom',
          align: 'center'
        }
      },
      {
        element: '[data-driver="recent-posts"]',
        popover: {
          title: 'Recent Posts',
          description: 'View your most recently created posts. Click on any post to view, edit, or publish it.',
          side: 'right',
          align: 'start'
        }
      },
      {
        element: '[data-driver="quick-actions"]',
        popover: {
          title: 'Quick Actions',
          description: 'Jump straight into content creation! Create individual posts, research keywords, or generate multiple posts at once with bulk creation.',
          side: 'left',
          align: 'start'
        }
      },
      {
        element: '[data-driver="getting-started"]',
        popover: {
          title: 'Getting Started Checklist',
          description: 'Follow these steps to get the most out of AutoScribe. Create a project, generate your first post, and publish it!',
          side: 'top',
          align: 'center'
        }
      },
      {
        element: '[data-driver="projects"]',
        popover: {
          title: 'Your Projects',
          description: 'Projects organize your content by website or topic. Each project can have its own settings, keywords, and posts.',
          side: 'right',
          align: 'start'
        }
      },
      {
        element: '[data-driver="nav-projects"]',
        popover: {
          title: 'Create Your First Project',
          description: 'Start by creating a project for your website. Go to Projects in the sidebar to get started!',
          side: 'right',
          align: 'start'
        }
      }
    ]
  }

  mobileSteps() {
    return [
      {
        element: '[data-driver="mobile-menu"]',
        popover: {
          title: 'Menu',
          description: 'Tap here to open the navigation menu and access all of AutoScribe\'s features.',
          side: 'bottom',
          align: 'start'
        }
      },
      {
        element: '[data-driver="metrics"]',
        popover: {
          title: 'Your Content Metrics',
          description: 'Track your content at a glance. See your total posts, published content, drafts, and keyword count.',
          side: 'bottom',
          align: 'center'
        }
      },
      {
        element: '[data-driver="quick-actions"]',
        popover: {
          title: 'Quick Actions',
          description: 'Jump straight into content creation! Create posts, research keywords, or generate multiple posts at once.',
          side: 'top',
          align: 'center'
        }
      },
      {
        element: '[data-driver="recent-posts"]',
        popover: {
          title: 'Recent Posts',
          description: 'View your most recently created posts. Tap on any post to view, edit, or publish it.',
          side: 'top',
          align: 'center'
        }
      },
      {
        element: '[data-driver="getting-started"]',
        popover: {
          title: 'Getting Started',
          description: 'Follow these steps to get started: create a project, generate your first post, and publish it!',
          side: 'top',
          align: 'center'
        }
      }
    ]
  }

  async markAsViewed() {
    await put('/profile/driver_viewed')
  }
}
